import React from "react";

export const PlusIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 14V8M8 8V2M8 8H14M8 8H2" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
  </svg>
);
